import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ICompanySettings } from 'auth/types';
import { Button } from 'core/components';
import { QuoteEntityType } from 'quotes/enums';
import { IQuoteVersionData } from 'quotes/types';
import { Variant } from 'theme/enums';

import { ChangeFreight } from './ChangeFreight';

interface IProps {
  quoteVersionData: IQuoteVersionData;
  partsTotal: number;
  freightSettings: Pick<ICompanySettings, 'defaultFreightPercentage' | 'minimumFreightCharge'>;
  quoteEntityType?: QuoteEntityType;
  onSubmitSuccess?: () => void;
}

export const ChangeFreightButton = ({
  quoteVersionData,
  partsTotal,
  freightSettings,
  quoteEntityType = QuoteEntityType.QUOTE,
  onSubmitSuccess,
}: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelChangeFreight')}
        variant={Variant.SOFT}
        onClick={() => setIsEditOpen(true)}
        sx={{
          marginLeft: 'var(--ag-grid-size)',
          marginRight: 'var(--ag-grid-size)',
        }}
      />

      <ChangeFreight
        quoteVersionData={quoteVersionData}
        partsTotal={partsTotal}
        freightSettings={freightSettings}
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        quoteEntityType={quoteEntityType}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
